import React, { useState } from "react";

import addEmailSignup from "@/api/requests/addEmailSignup";
import { useEventTracker } from "@/hooks/useEventTracker";
import { useSelector } from "@/redux/hooks";
import { getLocationState } from "@/redux/selectors/location";

import EmailSignup from "@/components/botanic/EmailSignup";
import TrackImpression from "@/components/TrackImpression";

type Source = "article-footer" | "article-inline";

const NewsEmailSignup = ({ source }: { source: Source }) => {
  const { publishEvent } = useEventTracker();

  const [isEmailSubmitted, setIsEmailSubmitted] = useState(false);
  const userLocation = useSelector(getLocationState);

  const submitEmailSignup = async (email: string) => {
    await addEmailSignup(email, userLocation, source);

    setIsEmailSubmitted(true);

    publishEvent({
      action: "click",
      category: "news",
      label: "newsletter sign up submitted",
    });
  };

  const { countryCode } = userLocation;

  return (
    <TrackImpression
      className="p-lg my-xxl bg-white rounded shadow-low border border-light-grey"
      category="news"
    >
      <div className="font-bold mb-lg text-lg">
        {countryCode === "CA"
          ? "Sign up for more Leafly news"
          : "Get good reads, local deals, and strain spotlights delivered right to your inbox."}
      </div>
      {isEmailSubmitted ? (
        <div className="text-md text-center my-xxl text-green font-bold">
          Thanks for signing up!
        </div>
      ) : (
        <EmailSignup onSubmit={submitEmailSignup} id="news-newsletter-signup" />
      )}
    </TrackImpression>
  );
};

export default NewsEmailSignup;
